import { useMemo } from 'react'

import { useBookkeepingBankAccounts } from './useBookkeepingBankAccounts'

export const useBookkeepingBankAccount = (accountId?: string) => {
  const { bookkeepingBankAccounts = [], isLoading } = useBookkeepingBankAccounts()
  const bookkeepingBankAccount = useMemo(
    () => bookkeepingBankAccounts.find((account) => account.id === accountId),
    [bookkeepingBankAccounts, accountId],
  )

  return {
    bookkeepingBankAccount,
    isLoading,
  }
}
